import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import SingleTeamTwo from '../../components/Team/SingleTeamTwo';

import shapeImg from '../../assets/img/about/shape-2-1.png';
import teamImg1 from '../../assets/img/team/team-2-1.png';
import teamImg2 from '../../assets/img/team/team-2-2.png';
import teamImg3 from '../../assets/img/team/team-2-3.png';
import teamImg4 from '../../assets/img/about/ed1.jpg';
import teamImg5 from '../../assets/img/team/ed.png';
import teamImg6 from '../../assets/img/team/drasim.png';
import teamImg7 from '../../assets/img/team/talhaBin.png';
import teamImg8 from '../../assets/img/team/syedahooria.png';
import edDocs from '../../assets/img/about/edmaam.png';

const Team = () => {
  return (
    <div
      id="it-team"
      className="it-team-2-area p-relative z-index pt-120 pb-90"
    >
      <div className="it-team-2-shape-2 d-none d-lg-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5">
            <SectionTitle
              itemClass="it-team-2-title-box text-center mb-60"
              subTitleClass="it-section-subtitle"
              subTitle="Our Doctor"
              title="How I Work To improve Hospital"
            />
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleTeamTwo
              teamImage={edDocs}
              authorName="Dr. Musfireh Siddiqeh"
              specialist="Executive Director"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleTeamTwo
              teamImage={teamImg6}
              authorName="Dr Asim Javed (Tamgha-e-Basalat)"
              specialist="Associate Professor"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleTeamTwo
              teamImage={teamImg7}
              authorName="Dr. Muhammad Talha Bin Nazir"
              specialist="Head Cardiac Electrophysiology"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleTeamTwo
              teamImage={teamImg8}
              authorName="Dr. Syeda Hooria Mohsin"
              specialist="MBBS, MPH"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
